
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindShaft9 as ObiWindShaft9Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-shaft-9.js';
 
 
 

 
 export const ObiWindShaft9 = createComponent({
   react: React,
   tagName: 'obi-wind-shaft-9',
   elementClass: ObiWindShaft9Element,
   events: {
     
   }
  });
 
 